/**
 * Тумблер.
 *
 * ОДИН НА ВЕСЬ КАБИНЕТ. Тумблеров скоро станет много: управление
 * кампанией, автопополнение, расписание, сторож — у каждой возможности
 * свой. Нарисованные порознь, они разойдутся в размере и в цвете, и это
 * заметно сразу: экран, собранный из чужих друг другу деталей, читается
 * как недоделанный.
 *
 * ЭТО КНОПКА, А НЕ КАРТИНКА. `role="switch"` и `aria-checked` нужны
 * не для галочки: без них с клавиатуры тумблер не нажать вовсе,
 * а именно с клавиатуры работают те, кто настраивает сорок кампаний
 * подряд.
 *
 * ПОДПИСЬ ГОВОРИТ О СОСТОЯНИИ, А НЕ О ДЕЙСТВИИ. «Включено» рядом
 * с включённым тумблером понятно всем; «Выключить» на включённом
 * тумблере читается двояко — то ли оно выключено, то ли предлагает
 * выключить.
 */
export function Switch({
  on,
  onChange,
  disabled,
  label,
  title,
  className,
}: {
  on: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  /** Для тех, кто не видит экрана. Рядом обычно стоит заголовок раздела. */
  label: string;
  title?: string;
  /**
   * Добавка к виду — для мест, где тумблер стоит в чужой раскладке.
   *
   * Плитка возможностей в эталоне — переносящийся ряд, и тумблер в нём
   * прижат вправо своим `margin-left: auto` и своим `order`. Ни того,
   * ни другого нельзя записать в общий `rk-switch`: в остальных
   * тринадцати местах тумблер стоит там, где поставлен.
   */
  className?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      title={title}
      disabled={disabled}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onChange(!on);
      }}
      /* РАЗМЕР ОДИН — 38×22, как в образце. Прежде он считался
         от переданного числа, и на трёх экранах тумблер получался
         трёх разных размеров. */
      className={className === undefined ? 'rk-switch' : `rk-switch ${className}`}
    >
      <span className="rk-switch-knob" />
    </button>
  );
}
